module.exports = new __parcel__URL__("figma.4fcb09e3.png").toString();